import {
  RAISE_CREDIT_NOTE,
  GET_CREDIT_NOTES,
  GET_CREDIT_NOTE_DETAILS,
  APPROVE_CREDIT_NOTE,
  REJECT_CREDIT_NOTE,
  CANCEL_CREDIT_NOTE,
  PROCESS_REFUND,
  GET_PENDING_COUNT,
} from "../actions/types";

const initialState = {
  creditNotesList: [],
  creditNoteDetails: null,
  pendingCount: 0,
  raiseStatus: null,
  approveStatus: null,
  rejectStatus: null,
  cancelStatus: null,
  processRefundStatus: null,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case RAISE_CREDIT_NOTE:
      return { ...state, raiseStatus: action.payload?.success };

    case GET_CREDIT_NOTES:
      return { 
        ...state, 
        creditNotesList: action.payload?.data || action.payload || [] 
      };

    case GET_CREDIT_NOTE_DETAILS:
      return { ...state, creditNoteDetails: action.payload?.data || null };

    case APPROVE_CREDIT_NOTE:
      return { ...state, approveStatus: action.payload?.success };

    case REJECT_CREDIT_NOTE:
      return { ...state, rejectStatus: action.payload?.success };

    case CANCEL_CREDIT_NOTE:
      return { ...state, cancelStatus: action.payload?.success };

    case PROCESS_REFUND:
      return { ...state, processRefundStatus: action.payload?.success };

    case GET_PENDING_COUNT:
      return {
        ...state,
        pendingCount: action.payload?.data?.pending || action.payload?.pending || 0,
      };

    default:
      return state;
  }
}